import { createApp } from 'vue';
import { AisInstantSearch, AisHits, AisConfigure } from 'vue-instantsearch/vue3/es';
import OfferAddressesSearch from '../offers/components/offer_addresses_search.vue';
import Inputmask from 'inputmask';
import $ from 'jquery';
import * as bootstrap from 'bootstrap';

// Function to initialize input masks
function initializeInputMasks() {
  // Date of birth mask
  const dateInput = document.querySelector('input[name="date_of_birth"]');
  if (dateInput) {
    Inputmask('99/99/9999', {
      placeholder: 'DD/MM/YYYY',
      showMaskOnHover: true,
      showMaskOnFocus: true,
      clearIncomplete: false,
    }).mask(dateInput);
  }
  
  // Client number mask - XXX-XXX-XXX format (9 digits with dashes)
  const clientNumberInput = document.querySelector('input[name="client_number"]');
  if (clientNumberInput) {
    Inputmask('999-999-999', {
      placeholder: '000-000-000',
      showMaskOnHover: true,
      showMaskOnFocus: true,
      clearIncomplete: false,
      removeMaskOnSubmit: true, // Remove dashes when submitting
    }).mask(clientNumberInput);
  }
}

// Initialize inputmask and modal behavior
$(function() {
  // Initialize masks on page load
  initializeInputMasks();
  
  // Handle modal showing for validate_card URL
  if (window.location.href.indexOf('validate_card') !== -1) {
    const el = document.getElementById('verify-card-modal');
    if (el) {
      const modal = bootstrap.Modal.getOrCreateInstance(el);
      modal.show();
    }
  }

  // Also initialize when modal is shown (in case it's dynamically loaded)
  const verifyCardModal = document.getElementById('verify-card-modal');
  if (verifyCardModal) {
    verifyCardModal.addEventListener('shown.bs.modal', function () {
      initializeInputMasks();
    });
  }
});

// Check if the element exists before mounting Vue app
const element = document.getElementById('offer-addresses-search-app');
if (element) {
  const offerId = element.dataset.offerId;
  
  if (offerId) {
    const app = createApp(OfferAddressesSearch, {
      offerId: parseInt(offerId),
    });
    
    // Register InstantSearch components globally for this app
    app.component('AisInstantSearch', AisInstantSearch);
    app.component('AisHits', AisHits);
    app.component('AisConfigure', AisConfigure);
    
    app.mount('#offer-addresses-search-app');
  }
}